import { getTrimTypeForConnectionAngle, islandHasCornerTrims } from '../helpers';
import { Panels } from '../../panels/panels.class';
import { PanelTrims } from '../panel-trims.class';

export const resetCfn = (panelTrims: PanelTrims, panels: Panels = null): void => {
	// purge existing panel trim entries
	panelTrims.children.forEach((pt) => panelTrims.delete(pt.id));

	// A finish with no corner trim hardware gets none created -- MOKS ships as one molded shell (#467)
	if (!islandHasCornerTrims(panelTrims.refMap.island)) return;

	// create new trim entries if panels were provided
	if (panels) {
		panels.children.forEach((panel) => {
			const connection = panel.connections.left;
			panelTrims.new(getTrimTypeForConnectionAngle(connection?.angle ?? null), [panel.id, connection.targetPanelId]);
		});
	}
};
